export const contentMotion = {
    initial: {},
    animate: {
        transition: {
            staggerChildren: .2,
            delayChildren: 1.2,
        }
    },
    exit: {}
}

export const titleMotion = {
    initial: {
        opacity: 0,
        y: 20,
    },
    animate: {
       opacity: 1,
       y: 0,
       transition: {
            ease: [0.99, 0.15, 0, 0.86],
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .5
        }
    }
}


export const optionMotion = {
    initial: {
        opacity: 0,
    },
    animate: {
       opacity: 1,
       transition: {
           ease: [0.99, 0.15, 0, 0.86],
       }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .5
        }
    }
}

export const notaMotion = {
    initial: {
        opacity: 0,
    },
    animate: {
       opacity: 1,
       transition: {
            delay: 1.5,
            ease: [0.99, 0.15, 0, 0.86],
       }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .5
        }
    }
}
